
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"y":".5","width":"24","height":"24","rx":"12","fill":"#00B900"}}),_c('path',{attrs:{"d":"M18.981 11.499c0-3.126-3.132-5.666-6.98-5.666-3.846 0-6.982 2.54-6.982 5.684 0 2.802 2.486 5.146 5.839 5.59.227.05.536.15.614.356.056.205.063.42.022.628l-.1.6c-.028.175-.138.69.608.377.746-.313 4.02-2.37 5.484-4.056 1.012-1.109 1.495-2.235 1.495-3.485","fill":"#fff"}}),_c('path',{attrs:{"d":"M10.58 9.99h-.49a.135.135 0 00-.134.134v3.044a.135.135 0 00.135.135h.49a.139.139 0 00.138-.135v-3.044a.138.138 0 00-.138-.135zM13.952 9.99h-.497a.135.135 0 00-.135.134v1.808l-1.393-1.883h-.604a.135.135 0 00-.135.136v3.044a.135.135 0 00.135.135h.498a.135.135 0 00.135-.135V11.36l1.396 1.886a.098.098 0 00.035.032h.565a.139.139 0 00.139-.135v-3.019a.138.138 0 00-.139-.135zM9.402 12.54H8.07v-2.416a.135.135 0 00-.135-.135h-.49a.135.135 0 00-.135.135v3.044a.128.128 0 00.039.093.124.124 0 00.092.039h1.957a.135.135 0 00.135-.135v-.487a.139.139 0 00-.135-.139M16.651 10.75a.135.135 0 00.135-.136v-.49a.135.135 0 00-.135-.135h-1.95a.132.132 0 00-.096.04.142.142 0 00-.035.092v3.044c0 .034.013.067.035.092.026.025.06.039.096.04h1.95a.135.135 0 00.135-.136v-.483a.139.139 0 00-.135-.139h-1.325v-.511h1.325a.135.135 0 00.135-.139v-.49a.135.135 0 00-.135-.12h-1.325v-.53h1.325z","fill":"#00B900"}})])
          )
        }
      }
    